import React from 'react';
import { Tooltip } from 'seagull';
import { SyncLiner24 } from 'seagull/icons';
import { QboIcon } from "../../../components/Integrations/QBO/QboIcon";
import { payoutIntegrationModel } from "../../../models";
function getTooltip(integration) {
  switch (integration.status) {
    case payoutIntegrationModel.Status.PendingSync:
      return payoutIntegrationModel.invoicesReady(integration) ? 'Pending payout sync' : 'Pending sync';
    case payoutIntegrationModel.Status.SyncInProgress:
      return 'Deposit sync in progress';
    case payoutIntegrationModel.Status.Synced:
      return 'Deposit recorded';
    case payoutIntegrationModel.Status.SyncFailed:
      return 'Deposit sync failed';
  }
}
function getIcon(integration) {
  switch (integration.status) {
    case payoutIntegrationModel.Status.PendingSync:
      return /*#__PURE__*/React.createElement(QboIcon, {
        intent: "pending"
      });
    case payoutIntegrationModel.Status.SyncInProgress:
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "qbo-in-progress"
      }, /*#__PURE__*/React.createElement(SyncLiner24, null));
    case payoutIntegrationModel.Status.Synced:
      return /*#__PURE__*/React.createElement(QboIcon, null);
    case payoutIntegrationModel.Status.SyncFailed:
      return /*#__PURE__*/React.createElement(QboIcon, {
        intent: "error"
      });
  }
}
export function PayoutQboIntegrationStatus(props) {
  const {
    testid,
    integration
  } = props;
  return integration ? /*#__PURE__*/React.createElement("div", {
    "data-testid": testid
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement("div", {
      "data-testid": "".concat(testid, "-tooltip")
    }, getTooltip(integration)),
    placement: "top",
    "data-testid": "".concat(testid, "-tooltip")
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-block'
    }
  }, getIcon(integration)))) : null;
}